import { Navigate, Route, Routes } from 'react-router-dom';
import { MainLayout } from '../components/layout/MainLayout';
import { JobPositionsPage } from '../pages/people/JobPositionsPage';
import { JobPositionAttributionsPage } from '../pages/people/JobPositionAttributionsPage';
import { JobAttributionKindsPage } from '../pages/people/JobAttributionKindsPage';
import { CompetenciesPage } from '../pages/people/CompetenciesPage';
import { CompetencyQuestionsPage } from '../pages/people/CompetencyQuestionsPage';
import { PerformanceIndicatorsPage } from '../pages/people/PerformanceIndicatorsPage';
import { EvaluationCycleDetailPage } from '../pages/people/EvaluationCycleDetailPage';
import { EvaluationFormDetailPage } from '../pages/people/EvaluationFormDetailPage';
import { EvaluationCyclesPage } from '../pages/people/EvaluationCyclesPage';
import { PerformanceEvaluationPage } from '../pages/people/PerformanceEvaluationPage';
import { NotesPage } from '../pages/people/NotesPage';
import { MyTeamPage } from '../pages/people/MyTeamPage';
import { MyTasksPage } from '../pages/tasks/MyTasksPage';
import { TasksInventoryPage } from '../pages/tasks/TasksInventoryPage';
import { MyTeamMemberProfilePage } from '../pages/people/MyTeamMemberProfilePage';
import { MyPerformancePage } from '../pages/performance/MyPerformancePage';
import { CycleFeedbackPage } from '../pages/performance/CycleFeedbackPage';
import { PeerReviewFormPage } from '../pages/performance/PeerReviewFormPage';
import { ModulesAdminPage } from '../pages/admin/ModulesAdminPage';
import { PermissionGroupsPage } from '../pages/admin/PermissionGroupsPage';
import { PermissionGroupEditorPage } from '../pages/admin/PermissionGroupEditorPage';
import { RolePermissionsPage } from '../pages/admin/RolePermissionsPage';
import { RolesAdminPage } from '../pages/admin/RolesAdminPage';
import { TeamMembersPage } from '../pages/admin/TeamMembersPage';
import { TeamsAdminPage } from '../pages/admin/TeamsAdminPage';
import { UsersAdminPage } from '../pages/admin/UsersAdminPage';
import { CollaboratorProfilePage } from '../pages/admin/CollaboratorProfilePage';
import { ForgotPasswordPage } from '../pages/auth/ForgotPasswordPage';
import { LoginPage } from '../pages/auth/LoginPage';
import { ResetPasswordPage } from '../pages/auth/ResetPasswordPage';
import { DashboardRouter } from '../pages/dashboard/DashboardRouter';
import { AreaDashboardPage } from '../pages/dashboard/AreaDashboardPage';
import { ProspectionDashboardPage } from '../pages/dashboard/ProspectionDashboardPage';
import { SystemSettingsPage } from '../pages/admin/SystemSettingsPage';
import { EmailTemplatesPage } from '../pages/admin/EmailTemplatesPage';
import { EmailQueuePage } from '../pages/admin/EmailQueuePage';
import { DecisionEnginePage } from '../pages/admin/DecisionEnginePage';
import { AccessDeniedPage } from '../pages/errors/AccessDeniedPage';
import { DocumentationExpiredPagesPage } from '../pages/documentation/DocumentationExpiredPagesPage';
import { DocumentationHomePage } from '../pages/documentation/DocumentationHomePage';
import { DocumentationViewsPage } from '../pages/documentation/DocumentationViewsPage';
import { DocumentationSpacePage } from '../pages/documentation/DocumentationSpacePage';
import { DocumentationPageEditorPage } from '../pages/documentation/DocumentationPageEditorPage';
import { PublicDocumentationPageView } from '../pages/documentation/PublicDocumentationPageView';
import {
  ManualDocumentationShell,
  ManualOwnerModuleRoute,
  ReleaseDocumentationShell,
} from '../pages/documentation/documentationShell';
import { ProductEditPage } from '../pages/sales/ProductEditPage';
import { ProductsPage } from '../pages/sales/ProductsPage';
import { ProductViewPage } from '../pages/sales/ProductViewPage';
import { CapabilitiesPage } from '../pages/sales/CapabilitiesPage';
import { MarketSegmentsPage } from '../pages/sales/MarketSegmentsPage';
import { ProductResourcesPage } from '../pages/sales/ProductResourcesPage';
import { BuyerPersonasPage } from '../pages/sales/BuyerPersonasPage';
import { ContractsPage } from '../pages/commercial/ContractsPage';
import { ProjectsPage } from '../pages/commercial/ProjectsPage';
import { ProjectDetailPage } from '../pages/commercial/ProjectDetailPage';
import { CompaniesPage } from '../pages/customerSuccess/CompaniesPage';
import { ContactsPage } from '../pages/customerSuccess/ContactsPage';
import { TicketsPage } from '../pages/customerSuccess/TicketsPage';
import { SupportDeskPage } from '../pages/customerSuccess/SupportDeskPage';
import { ProblemsPage } from '../pages/customerSuccess/ProblemsPage';
import { ServiceCatalogPage } from '../pages/customerSuccess/ServiceCatalogPage';
import { SupportAnalyticsPage } from '../pages/customerSuccess/SupportAnalyticsPage';
import { ChannelsPage } from '../pages/customerSuccess/ChannelsPage';
import { InboundMessagesPage } from '../pages/customerSuccess/InboundMessagesPage';
import { CannedResponsesPage } from '../pages/customerSuccess/CannedResponsesPage';
import { SurveyFormsPage } from '../pages/customerSuccess/SurveyFormsPage';
import { AccountHealthPage } from '../pages/customerSuccess/AccountHealthPage';
import { CsatDispatchReportPage } from '../pages/customerSuccess/CsatDispatchReportPage';
import { NpsDispatchReportPage } from '../pages/customerSuccess/NpsDispatchReportPage';
import { CustomerSuccessSettingsPage } from '../pages/customerSuccess/CustomerSuccessSettingsPage';
import { PublicSurveyPage } from '../pages/customerSuccess/PublicSurveyPage';
import { PortalAccountPage } from '../pages/portal/PortalAccountPage';
import { PortalDocumentationPage } from '../pages/portal/PortalDocumentationPage';
import { PortalFeedbackPage } from '../pages/portal/PortalFeedbackPage';
import { PortalHomePage } from '../pages/portal/PortalHomePage';
import { PortalLayout } from '../pages/portal/PortalLayout';
import { PortalConversationsPage } from '../pages/portal/PortalConversationsPage';
import { PortalPlaceholderPage } from '../pages/portal/PortalPlaceholderPage';
import { PortalProjectPage } from '../pages/portal/PortalProjectPage';
import { PortalProjectsPage } from '../pages/portal/PortalProjectsPage';
import { PortalRequestsPage } from '../pages/portal/PortalRequestsPage';
import { CommunicationAutomationsPage } from '../pages/customerSuccess/CommunicationAutomationsPage';
import { GtmAnalyticsPage } from '../pages/sales/GtmAnalyticsPage';
import { PricingPage } from '../pages/sales/PricingPage';
import { CampaignTagsPage } from '../pages/sales/CampaignTagsPage';
import { OpportunitiesPage } from '../pages/sales/OpportunitiesPage';
import { ProspectEditPage } from '../pages/sales/ProspectEditPage';
import { LeadsPage } from '../pages/sales/LeadsPage';
import { ProspectsPage } from '../pages/sales/ProspectsPage';
import { CalendarsPage } from '../pages/operations/CalendarsPage';
import { MonitorPage } from '../pages/monitor/MonitorPage';
import { MonitoringPage } from '../pages/monitoring/MonitoringPage';
import { AccessReportPage } from '../pages/reports/AccessReportPage';
import { StoragePage } from '../pages/storage/StoragePage';
import { StrategicPlanningPage } from '../pages/strategic-planning/StrategicPlanningPage';
import { TechnologyPlaceholderPage } from '../pages/technology/TechnologyPlaceholderPage';
import { TechnologyCatalogPage } from '../pages/technology/TechnologyCatalogPage';
import { TechnologyOverviewPage } from '../pages/technology/TechnologyOverviewPage';
import { TechnologyCertificatesPage } from '../pages/technology/TechnologyCertificatesPage';
import { TechnologyIntegrationsPage } from '../pages/technology/TechnologyIntegrationsPage';
import { TechnologyAiModelsPage } from '../pages/technology/TechnologyAiModelsPage';
import { TechnologyAiPromptsPage } from '../pages/technology/TechnologyAiPromptsPage';
import { TechnologyAiBenchmarksPage } from '../pages/technology/TechnologyAiBenchmarksPage';
import { TechnologyAiCostsPage } from '../pages/technology/TechnologyAiCostsPage';
import { TechnologyPortfolioPage } from '../pages/technology/TechnologyPortfolioPage';
import { TechnologyDeploymentsPage } from '../pages/technology/TechnologyDeploymentsPage';
import { TechnologyApplicationsPage } from '../pages/technology/TechnologyApplicationsPage';
import { TechnologySecretsPage } from '../pages/technology/TechnologySecretsPage';
import { TechnologyInfrastructurePage } from '../pages/technology/TechnologyInfrastructurePage';
import { TechnologyKeysPage } from '../pages/technology/TechnologyKeysPage';
import { CompanySettingsPage } from '../pages/settings/CompanySettingsPage';
import { ProfileSettingsPage } from '../pages/settings/ProfileSettingsPage';
import { PermissionRoute } from './PermissionRoute';
import { PortalRoute } from './PortalRoute';
import { ProtectedRoute } from './ProtectedRoute';
import { LoadingSpinner } from '../components/ui/LoadingSpinner';
import { useAuth } from '../contexts/AuthContext';

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/survey/:token" element={<PublicSurveyPage />} />
      <Route path="/docs/:token" element={<PublicDocumentationPageView />} />
      <Route path="/docs/:token/:pageSlug" element={<PublicDocumentationPageView />} />


      <Route element={<ProtectedRoute />}>
        <Route element={<MainLayout />}>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<DashboardRouter />} />
          <Route element={<PermissionRoute moduleCode="dashboard.prospection" />}>
            <Route path="/dashboard/prospection" element={<ProspectionDashboardPage />} />
          </Route>
          <Route element={<PermissionRoute moduleCode="dashboard.commercial" />}>
            <Route
              path="/commercial"
              element={
                <AreaDashboardPage
                  area="commercial"
                  title="Comercial"
                  description="Pipeline, contratos e tarefas comerciais no seu escopo de acesso."
                />
              }
            />
          </Route>
          <Route element={<PermissionRoute moduleCode="dashboard.operations" />}>
            <Route
              path="/operations"
              element={
                <AreaDashboardPage
                  area="operations"
                  title="Operações"
                  description="Planejamento estratégico e execução operacional no seu escopo de acesso."
                />
              }
            />
          </Route>
          <Route element={<PermissionRoute moduleCode="dashboard.marketing" />}>
            <Route
              path="/marketing"
              element={
                <AreaDashboardPage
                  area="marketing"
                  title="Marketing"
                  description="Prospecção, campanhas e enriquecimento de leads no seu escopo de acesso."
                />
              }
            />
          </Route>
          <Route element={<PermissionRoute moduleCode="dashboard.people" />}>
            <Route
              path="/people"
              element={
                <AreaDashboardPage
                  area="people"
                  title="Pessoas"
                  description="Colaboradores, equipes e estrutura organizacional no seu escopo de acesso."
                />
              }
            />
          </Route>
          <Route element={<PermissionRoute moduleCode="dashboard.customer-success" />}>
            <Route
              path="/customer-success"
              element={
                <AreaDashboardPage
                  area="customer-success"
                  title="Sucesso do Cliente"
                  description="Atendimento, chamados, problemas e canais no seu escopo de acesso."
                />
              }
            />
          </Route>
          <Route element={<PermissionRoute moduleCode="dashboard.relationship" />}>
            <Route
              path="/relationship"
              element={
                <AreaDashboardPage
                  area="relationship"
                  title="Relacionamento"
                  description="Clientes, contatos e contratos no seu escopo de acesso."
                />
              }
            />
          </Route>
          <Route path="/access-denied" element={<AccessDeniedPage />} />
          <Route path="/settings/profile" element={<ProfileSettingsPage />} />
          <Route element={<PermissionRoute requireAdmin />}>
            <Route path="/settings/company" element={<CompanySettingsPage />} />
          </Route>
          <Route path="/tasks" element={<MyTasksPage mode="tasks" />} />
          <Route path="/tasks/goals" element={<MyTasksPage mode="goals-milestones" />} />
          <Route path="/tasks/inventory" element={<TasksInventoryPage />} />
          <Route path="/performance" element={<MyPerformancePage />} />
          <Route path="/performance/notes" element={<NotesPage />} />
          <Route
            path="/performance/evaluations/:cycleId/:evaluationId"
            element={<PerformanceEvaluationPage />}
          />
          <Route path="/performance/feedback/:cycleId" element={<CycleFeedbackPage />} />
          <Route
            path="/performance/peer-reviews/:cycleId/:peerReviewId"
            element={<PeerReviewFormPage />}
          />

          <Route element={<PermissionRoute moduleCode="people.notes" />}>
            <Route path="/people/notes" element={<NotesPage />} />
          </Route>
          <Route element={<PermissionRoute moduleCode="people.my-team" />}>
            <Route path="/people/my-team" element={<MyTeamPage />} />
            <Route path="/people/my-team/members/:userId" element={<MyTeamMemberProfilePage />} />
          </Route>
          <Route element={<PermissionRoute moduleCode="access-control.users" />}>
            <Route path="/admin/users" element={<UsersAdminPage />} />
            <Route path="/admin/users/:userId/profile" element={<CollaboratorProfilePage />} />
          </Route>

          <Route element={<PermissionRoute moduleCode="access-control.teams" />}>
            <Route path="/admin/teams" element={<TeamsAdminPage />} />
            <Route path="/admin/teams/:teamId/members" element={<TeamMembersPage />} />
          </Route>

          <Route element={<PermissionRoute moduleCode="access-control.roles" />}>
            <Route path="/admin/roles" element={<RolesAdminPage />} />
            <Route path="/admin/roles/:roleId/permissions" element={<RolePermissionsPage />} />
          </Route>

          <Route element={<PermissionRoute moduleCode="access-control.permission-groups" />}>
            <Route path="/admin/permission-groups" element={<PermissionGroupsPage />} />
            <Route path="/admin/permission-groups/:groupId" element={<PermissionGroupEditorPage />} />
          </Route>

          <Route element={<PermissionRoute moduleCode="people.job-positions" />}>
            <Route path="/people/job-positions" element={<JobPositionsPage />} />
            <Route
              path="/people/job-positions/:jobPositionId/attributions"
              element={<JobPositionAttributionsPage />}
            />
            <Route path="/people/job-attribution-kinds" element={<JobAttributionKindsPage />} />
          </Route>

          <Route element={<PermissionRoute moduleCode="people.competencies" />}>
            <Route path="/people/performance-indicators" element={<PerformanceIndicatorsPage />} />
            <Route path="/people/competencies" element={<CompetenciesPage />} />
            <Route path="/people/competency-questions" element={<CompetencyQuestionsPage />} />
          </Route>

          <Route element={<PermissionRoute moduleCode="people.evaluations" />}>
            <Route path="/people/evaluation-cycles" element={<EvaluationCyclesPage />} />
            <Route path="/people/evaluation-cycles/:cycleId" element={<EvaluationCycleDetailPage />} />
            <Route
              path="/people/evaluation-cycles/:cycleId/forms/:formId"
              element={<EvaluationFormDetailPage />}
            />
            <Route
              path="/people/evaluation-cycles/:cycleId/evaluations/:evaluationId"
              element={<PerformanceEvaluationPage />}
            />
          </Route>

          <Route element={<PermissionRoute moduleCode="access-control.modules" />}>
            <Route path="/admin/modules" element={<ModulesAdminPage />} />
          </Route>

          <Route element={<PermissionRoute moduleCode="settings.system" />}>
            <Route path="/admin/settings" element={<SystemSettingsPage />} />
          </Route>

          <Route element={<PermissionRoute moduleCode="settings.email-templates" />}>
            <Route path="/admin/email-templates" element={<EmailTemplatesPage />} />
          </Route>
          <Route element={<PermissionRoute moduleCode="settings.email-queue" />}>
            <Route path="/admin/email-queue" element={<EmailQueuePage />} />
          </Route>
          <Route element={<PermissionRoute moduleCode="settings.decision-engine" />}>
            <Route path="/admin/decision-engine" element={<DecisionEnginePage />} />
          </Route>

          <Route element={<PermissionRoute moduleCode="storage" />}>
            <Route path="/admin/storage" element={<StoragePage />} />
          </Route>

          <Route element={<PermissionRoute moduleCode="sales.products" />}>
            <Route path="/sales/offer" element={<ProductsPage scope="offer" />} />
            <Route path="/sales/products" element={<ProductsPage scope="commercial" />} />
            <Route path="/sales/products/new" element={<ProductEditPage scope="commercial" />} />
            <Route path="/sales/products/:id" element={<ProductViewPage />} />
            <Route path="/sales/products/:id/edit" element={<ProductEditPage scope="commercial" />} />
          </Route>

          <Route element={<PermissionRoute moduleCode="products.workspace" />}>
            <Route path="/products" element={<ProductsPage scope="product" />} />
            <Route path="/products/new" element={<ProductEditPage scope="product" />} />
            <Route path="/products/:id" element={<ProductEditPage scope="product" />} />
          </Route>

          <Route element={<PermissionRoute moduleCode="sales.pricing" />}>
            <Route path="/sales/pricing" element={<PricingPage />} />
          </Route>

          <Route element={<PermissionRoute moduleCode="sales.capabilities" />}>
            <Route path="/sales/capabilities" element={<CapabilitiesPage />} />
          </Route>

          <Route element={<PermissionRoute moduleCode="sales.market-segments" />}>
            <Route path="/sales/market-segments" element={<MarketSegmentsPage />} />
          </Route>

          <Route element={<PermissionRoute moduleCode="sales.product-resources" />}>
            <Route path="/sales/product-resources" element={<ProductResourcesPage />} />
          </Route>

          <Route element={<PermissionRoute moduleCode="sales.buyer-personas" />}>
            <Route path="/sales/buyer-personas" element={<BuyerPersonasPage />} />
          </Route>

          <Route element={<PermissionRoute moduleCode="sales.gtm-analytics" />}>
            <Route path="/sales/gtm-analytics" element={<GtmAnalyticsPage />} />
          </Route>

          <Route element={<PermissionRoute moduleCode="sales.campaign-tags" />}>
            <Route path="/sales/campaign-tags" element={<CampaignTagsPage />} />
          </Route>

          <Route element={<PermissionRoute moduleCode="sales.opportunities" />}>
            <Route path="/sales/opportunities" element={<OpportunitiesPage />} />
          </Route>

          <Route element={<PermissionRoute moduleCode="commercial.contracts" />}>
            <Route path="/commercial/contracts" element={<ContractsPage />} />
          </Route>

          <Route element={<PermissionRoute moduleCode="commercial.projects" />}>
            <Route path="/commercial/projects" element={<ProjectsPage />} />
            <Route path="/commercial/projects/:projectId" element={<ProjectDetailPage />} />
          </Route>

          <Route element={<PermissionRoute moduleCode="sales.prospects" />}>
            <Route path="/sales/prospects" element={<ProspectsPage />} />
            <Route path="/sales/leads" element={<LeadsPage />} />
            <Route path="/sales/leads/new" element={<ProspectEditPage />} />
            <Route path="/sales/leads/:id/edit" element={<ProspectEditPage />} />
            <Route path="/sales/prospects/new" element={<ProspectEditPage />} />
            <Route path="/sales/prospects/:id/edit" element={<ProspectEditPage />} />
          </Route>

          <Route element={<PermissionRoute moduleCode="core.companies" />}>
            <Route path="/core/companies" element={<CompaniesPage />} />
          </Route>

          <Route element={<PermissionRoute moduleCode="core.contacts" />}>
            <Route path="/core/contacts" element={<ContactsPage />} />
          </Route>

          <Route element={<PermissionRoute moduleCode="customer-success.desk" />}>
            <Route path="/customer-success/desk" element={<SupportDeskPage />} />
          </Route>

          <Route element={<PermissionRoute moduleCode="customer-success.tickets" />}>
            <Route path="/customer-success/tickets" element={<TicketsPage />} />
          </Route>

          <Route element={<PermissionRoute moduleCode="customer-success.service-catalog" />}>
            <Route path="/customer-success/service-catalog" element={<ServiceCatalogPage />} />
          </Route>

          <Route element={<PermissionRoute moduleCode="customer-success.analytics" />}>
            <Route path="/customer-success/analytics" element={<SupportAnalyticsPage />} />
          </Route>

          <Route element={<PermissionRoute moduleCode="customer-success.channels" />}>
            <Route path="/customer-success/channels" element={<ChannelsPage />} />
          </Route>

          <Route element={<PermissionRoute moduleCode="customer-success.inbound" />}>
            <Route path="/customer-success/inbound" element={<InboundMessagesPage />} />
          </Route>

          <Route element={<PermissionRoute moduleCode="customer-success.problems" />}>
            <Route path="/customer-success/problems" element={<ProblemsPage />} />
          </Route>

          <Route element={<PermissionRoute moduleCode="customer-success.engagement" />}>
            <Route path="/customer-success/engagement" element={<CannedResponsesPage />} />
            <Route path="/customer-success/survey-forms" element={<SurveyFormsPage />} />
            <Route
              path="/customer-success/messages"
              element={<Navigate to="/customer-success/settings?tab=emails" replace />}
            />
            <Route path="/customer-success/automations" element={<CommunicationAutomationsPage />} />
          </Route>

          <Route element={<PermissionRoute moduleCode="customer-success.health" />}>
            <Route path="/customer-success/health" element={<AccountHealthPage />} />
            <Route path="/customer-success/csat-report" element={<CsatDispatchReportPage />} />
            <Route path="/customer-success/nps-report" element={<NpsDispatchReportPage />} />
          </Route>

          <Route element={<PermissionRoute moduleCode="customer-success.settings" />}>
            <Route path="/customer-success/settings" element={<CustomerSuccessSettingsPage />} />
          </Route>

          <Route element={<PermissionRoute moduleCode="operations.calendars" />}>
            <Route path="/operations/calendars" element={<CalendarsPage />} />
            <Route path="/operations/calendars/:id" element={<Navigate to="/operations/calendars" replace />} />
          </Route>

          <Route element={<PermissionRoute moduleCode="monitor" />}>
            <Route path="/monitor" element={<MonitorPage />} />
          </Route>

          <Route element={<PermissionRoute moduleCode="monitoring" />}>
            <Route path="/monitoring" element={<MonitoringPage />} />
          </Route>

          <Route element={<PermissionRoute moduleCode="reports.access" />}>
            <Route path="/reports/access" element={<AccessReportPage />} />
          </Route>

          <Route element={<PermissionRoute moduleCode="strategic-planning" />}>
            <Route path="/strategic-planning" element={<StrategicPlanningPage />} />
          </Route>

          <Route element={<PermissionRoute moduleCode="technology.overview" />}>
            <Route path="/technology/overview" element={<TechnologyOverviewPage />} />
          </Route>
          <Route element={<PermissionRoute moduleCode="technology.catalog" />}>
            <Route path="/technology/catalog" element={<TechnologyCatalogPage />} />
          </Route>
          <Route element={<PermissionRoute moduleCode="technology.applications" />}>
            <Route path="/technology/applications" element={<TechnologyApplicationsPage />} />
          </Route>
          <Route element={<PermissionRoute moduleCode="technology.portfolio" />}>
            <Route path="/technology/portfolio" element={<TechnologyPortfolioPage />} />
          </Route>
          <Route element={<PermissionRoute moduleCode="technology.infrastructure" />}>
            <Route path="/technology/infrastructure" element={<TechnologyInfrastructurePage />} />
          </Route>
          <Route element={<PermissionRoute moduleCode="technology.integrations" />}>
            <Route path="/technology/integrations" element={<TechnologyIntegrationsPage />} />
          </Route>
          <Route element={<PermissionRoute moduleCode="technology.secrets" />}>
            <Route path="/technology/secrets" element={<TechnologySecretsPage />} />
          </Route>
          <Route element={<PermissionRoute moduleCode="technology.certificates" />}>
            <Route path="/technology/certificates" element={<TechnologyCertificatesPage />} />
          </Route>
          <Route element={<PermissionRoute moduleCode="technology.keys" />}>
            <Route path="/technology/keys" element={<TechnologyKeysPage />} />
          </Route>
          <Route element={<PermissionRoute moduleCode="technology.ai-models" />}>
            <Route path="/technology/ai/models" element={<TechnologyAiModelsPage />} />
          </Route>
          <Route element={<PermissionRoute moduleCode="technology.ai-prompts" />}>
            <Route path="/technology/ai/prompts" element={<TechnologyAiPromptsPage />} />
          </Route>
          <Route element={<PermissionRoute moduleCode="technology.ai-benchmarks" />}>
            <Route path="/technology/ai/benchmarks" element={<TechnologyAiBenchmarksPage />} />
          </Route>
          <Route element={<PermissionRoute moduleCode="technology.ai-costs" />}>
            <Route path="/technology/ai/costs" element={<TechnologyAiCostsPage />} />
          </Route>
          <Route element={<ManualDocumentationShell />}>
            <Route element={<PermissionRoute moduleCode="manual" />}>
              <Route path="/manual" element={<DocumentationHomePage />} />
              <Route element={<ManualOwnerModuleRoute moduleCode="manual.expired" />}>
                <Route path="/manual/expired" element={<DocumentationExpiredPagesPage />} />
              </Route>
              <Route element={<ManualOwnerModuleRoute moduleCode="manual.views" />}>
                <Route path="/manual/views" element={<DocumentationViewsPage />} />
              </Route>
              <Route path="/manual/:spaceId/pages/new" element={<DocumentationPageEditorPage />} />
              <Route path="/manual/:spaceId/pages/:pageId/edit" element={<DocumentationPageEditorPage />} />
              <Route path="/manual/:spaceId/pages/:pageId" element={<DocumentationSpacePage />} />
              <Route path="/manual/:spaceId" element={<DocumentationSpacePage />} />
            </Route>
          </Route>
          <Route element={<PermissionRoute moduleCode="technology.documentation" />}>
            <Route path="/technology/documentation" element={<DocumentationHomePage />} />
            <Route path="/technology/documentation/expired" element={<DocumentationExpiredPagesPage />} />
            <Route path="/technology/documentation/views" element={<DocumentationViewsPage />} />
            <Route
              path="/technology/documentation/:spaceId/pages/new"
              element={<DocumentationPageEditorPage />}
            />
            <Route
              path="/technology/documentation/:spaceId/pages/:pageId/edit"
              element={<DocumentationPageEditorPage />}
            />
            <Route path="/technology/documentation/:spaceId/pages/:pageId" element={<DocumentationSpacePage />} />
            <Route path="/technology/documentation/:spaceId" element={<DocumentationSpacePage />} />
          </Route>
          <Route element={<PermissionRoute moduleCode="technology.deployments" />}>
            <Route element={<ReleaseDocumentationShell />}>
              <Route path="/technology/deployments/documentation" element={<DocumentationHomePage />} />
              <Route
                path="/technology/deployments/documentation/:spaceId/pages/new"
                element={<DocumentationPageEditorPage />}
              />
              <Route
                path="/technology/deployments/documentation/:spaceId/pages/:pageId/edit"
                element={<DocumentationPageEditorPage />}
              />
              <Route
                path="/technology/deployments/documentation/:spaceId/pages/:pageId"
                element={<DocumentationSpacePage />}
              />
              <Route
                path="/technology/deployments/documentation/:spaceId"
                element={<DocumentationSpacePage />}
              />
            </Route>
            <Route path="/technology/deployments" element={<TechnologyDeploymentsPage />} />
          </Route>
          <Route element={<PermissionRoute moduleCode="technology.backups" />}>
            <Route
              path="/technology/backups"
              element={<TechnologyPlaceholderPage moduleCode="technology.backups" />}
            />
          </Route>
          <Route element={<PermissionRoute moduleCode="technology.monitoring" />}>
            <Route
              path="/technology/monitoring"
              element={<TechnologyPlaceholderPage moduleCode="technology.monitoring" />}
            />
          </Route>
        </Route>
      </Route>

      <Route element={<PortalRoute />}>
      <Route path="/portal" element={<PortalLayout />}>
        <Route index element={<PortalHomePage />} />
        <Route path="projects" element={<PortalProjectsPage />} />
        <Route path="projects/:projectId" element={<PortalProjectPage />} />
        <Route
          path="documents"
          element={
            <PortalPlaceholderPage
              title="Documentos"
              description="Contratos, propostas, atas e entregáveis da sua empresa."
            />
          }
        />
        <Route path="conversations" element={<PortalConversationsPage />} />
        <Route path="requests" element={<PortalRequestsPage />} />
        <Route
          path="reports"
          element={
            <PortalPlaceholderPage
              title="Relatórios"
              description="Indicadores e acompanhamentos consolidados."
            />
          }
        />
        <Route
          path="notifications"
          element={
            <PortalPlaceholderPage
              title="Notificações"
              description="Atualizações, lembretes e acontecimentos importantes."
            />
          }
        />
        <Route path="documentation" element={<PortalDocumentationPage />} />
        <Route path="documentation/:pageId" element={<PortalDocumentationPage />} />
        <Route path="feedback" element={<PortalFeedbackPage />} />
        <Route path="feedback/:feedbackId" element={<PortalFeedbackPage />} />
        <Route path="account" element={<PortalAccountPage mode="profile" />} />
        <Route path="account/profile" element={<PortalAccountPage mode="profile" />} />
        <Route path="account/password" element={<PortalAccountPage mode="password" />} />
      </Route>
      </Route>

      <Route path="*" element={<SessionHomeRedirect />} />
    </Routes>
  );
}

function SessionHomeRedirect() {
  const { isLoading, profile } = useAuth();

  if (isLoading) {
    return <LoadingSpinner label="Validando sessão..." />;
  }

  if (profile?.portalOnly) {
    return <Navigate to="/portal" replace />;
  }

  return <Navigate to="/dashboard" replace />;
}
